import { motion } from 'framer-motion';
import { Bell, ShoppingCart, TrendingUp, Zap, Check } from 'lucide-react';
import { useEffect } from 'react';

interface NotificationToastProps {
    notification: any;
    onClose: () => void;
    onClick: () => void;
}

export const ToastNotification = ({ notification, onClose, onClick }: NotificationToastProps) => {
    useEffect(() => {
        const timer = setTimeout(onClose, 5000);
        return () => clearTimeout(timer);
    }, [onClose]);

    const getIcon = (type: string) => {
        switch (type?.toLowerCase()) {
            case 'sale': return <TrendingUp size={16} className="text-green-500" />;
            case 'purchase': return <ShoppingCart size={16} className="text-blue-500" />;
            case 'bid': return <Zap size={16} className="text-purple-500" />;
            case 'outbid': return <Bell size={16} className="text-orange-500" />;
            case 'p2p_complete': return <Check size={16} className="text-emerald-500" />;
            default: return <Bell size={16} className="text-white" />;
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: -80, scale: 0.9 }}
            animate={{
                opacity: 1,
                y: 56,
                scale: 1,
                transition: {
                    type: "spring",
                    stiffness: 350,
                    damping: 25,
                    delay: 0.05
                }
            }}
            exit={{
                opacity: 0,
                scale: 0.1,
                x: 120,
                y: -40,
                transition: { duration: 0.5, ease: [0.32, 0, 0.67, 0] }
            }}
            onClick={onClick}
            className={`fixed top-0 right-4 left-4 z-[40] bg-[#1c1c1e]/98 backdrop-blur-3xl border ${notification.type === 'outbid' ? 'border-orange-500/60 shadow-[0_0_20px_rgba(249,115,22,0.2)]' : 'border-white/5'} p-3 rounded-2xl shadow-[0_40px_80px_rgba(0,0,0,0.9)] flex items-center gap-3 cursor-pointer active:scale-95 transition-all`}
        >
            <div className={`w-9 h-9 rounded-full bg-white/5 flex items-center justify-center border ${notification.type === 'outbid' ? 'border-orange-500/30' : 'border-white/5'}`}>
                {getIcon(notification.type)}
            </div>
            <div className="flex-1 min-w-0">
                <h4 className="text-white font-bold text-sm truncate">{notification.title}</h4>
                <p className="text-white/60 text-xs truncate whitespace-nowrap overflow-hidden">{notification.message}</p>
            </div>
            <div className="w-1 h-1 rounded-full bg-blue-500 animate-pulse" />
        </motion.div>
    );
};
